import { Modal } from 'is24-corecss';
import ModalV2 from '@/components/common/display/modal/ModalV2';
import type { BenefitModalProps } from '@/@types/benefitModalProps';
import { Benefit } from '@/@types/benefits';
import { campaigns } from '@/components/common/campaigns';
import { useAdacStatus } from '@/customHooks/useAdacStatus';
import useNavigationPaths from '@/customHooks/useNavigationPaths.hook';
import { useIntl } from '@/i18n';
import { OverviewTab } from './OverviewTab';
import image from './adac-home-protection.jpg';
import imageWebp from './adac-home-protection.webp';

export const Adac = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const { isEntitled } = useAdacStatus();
  const { navigateToBenefit } = useNavigationPaths();

  return (
    <ModalV2
      title={t({ id: 'benefits.adac.headline' })}
      isVisible={isVisible}
      onClose={onClose}
      benefit={Benefit.ADAC}
      image={image}
      imageWebp={imageWebp}
      imageAlt={t({ id: 'benefits.adac.modal.image' })}
      imageUseFullWidth={true}
      tabsContent={[<OverviewTab key='overview' />]}
      primaryFooterBtn={
        <Modal.FooterButton
          variant='filledBrand'
          label={t({ id: isEntitled ? 'benefits.adac.modal.activate' : 'common.buttons.discoverWohnenPlus' })}
          onClick={isEntitled ? undefined : () => navigateToBenefit(campaigns.ADAC_MEIN_PLUS)}
        />
      }
    />
  );
};
